import { Box, useMantineTheme, createStyles } from '@mantine/core';
import { IconCheck, IconCircleFilled } from '@tabler/icons-react';

import { Text } from '~/domains/design-system/Text';
import dt from '~/testing';

interface PasswordRequirementProps {
  isValid: boolean;
  label: string;
}

const useStyles = createStyles((theme) => ({
  iconCircle: {
    color: theme.colors.gray2[1],
    margin: /* eslint-disable-line local-rules/use-theme-tokens */ '0 6px',
  },
}));

export default function PasswordRequirement({ isValid, label }: PasswordRequirementProps) {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  return (
    <Text
      color={isValid ? 'gray2.3' : 'gray2.6'}
      data-test-id={dt.components.shared.auth.passwordRequirement}
      variant="body-large"
      sx={{ display: 'flex', alignItems: 'center' }}
    >
      {isValid ? (
        <IconCheck
          data-test-id={dt.components.shared.auth.passwordRequirementCheckIcon}
          size={24}
          color={theme.colors.blue[7]}
        />
      ) : (
        <IconCircleFilled
          data-test-id={dt.components.shared.auth.passwordRequirementXIcon}
          size={8}
          className={classes.iconCircle}
        />
      )}
      <Box /* eslint-disable-line local-rules/use-theme-tokens */ ml={10}>{label}</Box>
    </Text>
  );
}
